import React, {useState} from 'react';
import Container from '@material-ui/core/Container';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import {updateObject} from '../../shared/utility';
import {
    StyledButton,
    StyledTextField,
    StyledSlider,
} from './styledMaterialComponents';
import styles from './subscriptionDetails.module.css';

const sliderSteps = [
    {
        value: 1,
        label: '1 miesiąc',
    },
    {
        value: 3,
        label: '3 miesiące',
    },
    {
        value: 6,
        label: '6 miesięcy',
    },
    {
        value: 12,
        label: '12 miesięcy',
    },
];

const FirstPage = ({subscriptionDetails, updateSubscriptionDetails, price}) => {
    const [emailIsValid, setEmailIsValid] = useState(false);
    const [emailWasTouched, seTemailWasTouched] = useState(false);

    const onSubscriptionBeginChanged = event => {
        const updatedDetails = updateObject(subscriptionDetails, {
            subscriptionBegin: event.target.value,
        });
        const validatedDetailes = updateObject(updatedDetails, {
            isValid: checkValidation(updatedDetails),
        });
        updateSubscriptionDetails(validatedDetailes);
    };

    const onSubscriptionLengthChanged = value => {
        const updatedDetails = updateObject(subscriptionDetails, {
            subscriptionLength: value,
            addInfuser: false,
            addBidon: false,
        });

        if (value >= 3) {
            updatedDetails.addInfuser = true;
        }
        if (value >= 12) {
            updatedDetails.addBidon = true;
        }

        const validatedDetailes = updateObject(updatedDetails, {
            isValid: checkValidation(updatedDetails),
        });
        updateSubscriptionDetails(validatedDetailes);
    };

    const onPackingMethodChanged = method => {
        const updatedDetails = updateObject(subscriptionDetails, {
            packingMethod: method,
        });
        const validatedDetailes = updateObject(updatedDetails, {
            isValid: checkValidation(updatedDetails),
        });
        updateSubscriptionDetails(validatedDetailes);
    };

    const onAddBidonClicked = () => {
        const updatedDetails = updateObject(subscriptionDetails, {
            addBidon: !subscriptionDetails.addBidon,
        });
        const validatedDetailes = updateObject(updatedDetails, {
            isValid: checkValidation(updatedDetails),
        });
        updateSubscriptionDetails(validatedDetailes);
    };

    const onAddInfuserClicked = () => {
        const updatedDetails = updateObject(subscriptionDetails, {
            addInfuser: !subscriptionDetails.addInfuser,
        });
        const validatedDetailes = updateObject(updatedDetails, {
            isValid: checkValidation(updatedDetails),
        });
        updateSubscriptionDetails(validatedDetailes);
    };

    const validateEmail = email => {
        const pattern = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;
        return pattern.test(email);
    };

    const onEmailChanged = event => {
        setEmailIsValid(validateEmail(event.target.value));
        seTemailWasTouched(true);
        const updatedDetails = updateObject(subscriptionDetails, {
            email: event.target.value,
        });
        const validatedDetailes = updateObject(updatedDetails, {
            isValid: checkValidation(updatedDetails),
        });
        updateSubscriptionDetails(validatedDetailes);
    };

    const checkValidation = updatedDetails => {
        if (
            updatedDetails.subscriptionBegin !== '' &&
            validateEmail(updatedDetails.email) === true
        ) {
            return true;
        } else {
            return false;
        }
    };

    const PackingMethodButons = () => (
        <React.Fragment>
            <StyledButton
                variant={
                    subscriptionDetails.packingMethod === 'BOX'
                        ? 'contained'
                        : 'outlined'
                }
                color="primary"
                size="large"
                onClick={() => {
                    onPackingMethodChanged('BOX');
                }}>
                Pudełko wielorazowe
            </StyledButton>
            <StyledButton
                variant={
                    subscriptionDetails.packingMethod === 'BAG'
                        ? 'contained'
                        : 'outlined'
                }
                color="primary"
                size="large"
                onClick={() => {
                    onPackingMethodChanged('BAG');
                }}>
                Torba jednorazowa
            </StyledButton>
        </React.Fragment>
    );

    const BidonButton = () => (
        <StyledButton
            variant={subscriptionDetails.addBidon ? 'contained' : 'outlined'}
            color="primary"
            size="large"
            onClick={() => onAddBidonClicked()}>
            <div className={styles.subscriptionDetailsButton}>
                <Typography variant="h6">Termos</Typography>
                <Typography variant="caption">
                    {subscriptionDetails.subscriptionLength >= 12 ? (
                        <>
                            <del>+80zł</del> Za darmo
                        </>
                    ) : (
                        <>+80zł</>
                    )}
                </Typography>
            </div>
        </StyledButton>
    );

    const InfuserButton = () => (
        <StyledButton
            variant={subscriptionDetails.addInfuser ? 'contained' : 'outlined'}
            color="primary"
            size="large"
            onClick={() => onAddInfuserClicked()}>
            <div className={styles.subscriptionDetailsButton}>
                <Typography variant="h6">Zaparzacz</Typography>
                <Typography variant="caption">
                    {subscriptionDetails.subscriptionLength >= 3 ? (
                        <>
                            <del>+10zł</del> Za darmo
                        </>
                    ) : (
                        <>+10zł</>
                    )}
                </Typography>
            </div>
        </StyledButton>
    );

    return (
        <Container maxWidth="sm">
            <Grid container spacing={2} justify="center" alignItems="center">
                <Grid item xs={12} container justify="center">
                    <Typography id="range-slider" gutterBottom>
                        Cena za miesiąc:
                    </Typography>
                    <Typography>
                        <b className={styles.priceText}>{price}zł</b>
                    </Typography>
                </Grid>
                <Grid item xs={12} container justify="center">
                    <Typography id="range-slider" gutterBottom>
                        Długość abonamentu:
                    </Typography>
                    <StyledSlider
                        defaultValue={1}
                        aria-labelledby="discrete-slider"
                        valueLabelDisplay="auto"
                        step={null}
                        marks={sliderSteps}
                        min={1}
                        max={12}
                        value={subscriptionDetails.subscriptionLength}
                        onChange={(event, value) =>
                            onSubscriptionLengthChanged(value)
                        }
                    />
                </Grid>
                <Grid item xs={12} container justify="center">
                    <Typography id="range-slider" gutterBottom>
                        Metoda pakowania:
                    </Typography>
                    <Grid
                        item
                        xs={12}
                        container
                        direction="row"
                        justify="space-around"
                        alignItems="center">
                        <PackingMethodButons />
                    </Grid>
                </Grid>
                <Grid item xs={12} container justify="center">
                    <Typography id="range-slider" gutterBottom>
                        Dodaj do zamówienia:
                    </Typography>
                    <Grid
                        item
                        xs={12}
                        container
                        direction="row"
                        justify="space-around"
                        alignItems="center">
                        <BidonButton />
                        <InfuserButton />
                    </Grid>
                </Grid>
                <Grid item xs={12} container justify="center">
                    <StyledTextField
                        id="date"
                        label="Początek abonamentu"
                        type="date"
                        defaultValue={subscriptionDetails.subscriptionBegin}
                        fullWidth={true}
                        variant="outlined"
                        InputLabelProps={{
                            shrink: true,
                        }}
                        onChange={event => onSubscriptionBeginChanged(event)}
                    />
                </Grid>
                <Grid item xs={12} container justify="center">
                    <StyledTextField
                        value={subscriptionDetails.email}
                        error={!emailIsValid && emailWasTouched}
                        id="mail"
                        label="Twój adres email"
                        variant="outlined"
                        onChange={event => {
                            onEmailChanged(event);
                        }}
                    />
                </Grid>
            </Grid>
        </Container>
    );
};

export default FirstPage;
